import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ProductImage from './ProductImage';
import ProductInfo from './ProductInfo';

const Product = (props) => {
  const { className, children } = props;

  return <div className={cn('o-media  c-product', className)}>{children}</div>
};

export default Product;

Product.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Product.defaultProps = {
  className: '',
};

Product.Image = ProductImage;
Product.Info = ProductInfo;
